export default "__VITE_ASSET__ByNxeQ71__"